// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string(),
  armyId: __t.string().name("army_id"),
  archetype: __t.string(),
  customName: __t.string().name("custom_name"),
  slotIndex: __t.u32().name("slot_index"),
  isGeneral: __t.bool().name("is_general"),
  level: __t.u32(),
  experience: __t.u32(),
  troopsPercent: __t.f64().name("troops_percent"),
  kills: __t.u32(),
  battlesSurvived: __t.u32().name("battles_survived"),
  skills: __t.string(),
});
